module.exports = __webpack_public_path__ + "static/media/section1.c31cc493.jpeg";